import { atom } from 'jotai';

export const isNavigationOpenAtom = atom(true);
